"use strict";

module.exports = function () {
  for (var key in this.$refs.table.customQueries) {
    this.$refs.table.customQueries[key] = null;
  }

  this.$refs.table.updateState('customQueries', this.customQueries);
  this.$refs.table.refresh();
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-tables-2/compiled/methods/reset-custom-filters.js
// module id = AtY2
// module chunks = 0